import { useAppStore } from 'kfone-frontend-core';
import RedirectToLoginPage from 'pages/redirect-to-login';
import type { FC } from 'react';

export const withAuthorization = <P extends object>(WrappedComponent: FC<P>) => {
  const ComponentWithAuthorization: FC<P> = (props) => {
    const { isAuthenticated } = useAppStore();

    if (isAuthenticated ||  (window.location.hostname === 'localhost' && window.location.port === '3086')) {
      return <WrappedComponent {...props} />;
    }

    return <RedirectToLoginPage />;
  };

  ComponentWithAuthorization.displayName = `withAuthorization(${WrappedComponent.displayName ?? WrappedComponent.name ?? 'Component'})`;
  return ComponentWithAuthorization;
};